<div class="main vh-100 vw-100">

    <div class="d-flex flex-nowrap flex-column justify-content-stretch align-items-stretch h-100 v-100 m-0">

        <!-- Header -->
        <app-header class="header"></app-header>

        <div class="d-flex flex-column justify-content-start align-items-stretch h-100">

            <!-- Content -->
            <div class="content flex-grow-1">
                <router-outlet></router-outlet>
            </div>

            <!-- Footer -->
            <app-footer></app-footer>

        </div>

    </div>


</div>
